import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from 'view-design/dist/locale/en-US';
import zhCN from 'view-design/dist/locale/zh-CN';
Vue.use(VueI18n)
Vue.locale = () => {}

const iviewlang = {
  "en-US": enUS,
  "zh-CN": zhCN
}

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = Object.assign(locales(key), iviewlang[locale])
    }
  })
  return messages
}
const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'zh-CN',
  // fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'zh-CN',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true
})

export default i18n


